import React from 'react';
import { cn } from '../../utils/cn';

interface HeaderCtaProps {
  hasLoaded: boolean;
  children: React.ReactNode;
}

/**
 * Landing-page replacement for `Hamburger`: pins arbitrary content
 * (button, link, badge…) where the nav toggle would normally live —
 * top-right on desktop, bottom-right on mobile/landscape. Layout
 * mounts this when `headerCta` is provided. The fixed container is
 * `pointer-events: none` so it doesn't intercept clicks across the
 * full width — the inner slot re-enables pointer events around the
 * actual child so the caller doesn't need to remember.
 */
const HeaderCta = ({ hasLoaded, children }: HeaderCtaProps) => {
  const containerClasses = cn(
    'pointer-events-none fixed top-0 right-0 left-0 z-50 mx-auto flex w-full max-w-[1500px] justify-end p-[55px_50px] transition-opacity delay-[350ms] duration-300',
    'opacity-0',
    hasLoaded && 'opacity-100',
    'max-[1530px]:pt-[55px] max-[1530px]:pr-[60px]',
    'mobile-or-landscape:top-auto mobile-or-landscape:bottom-0 mobile-or-landscape:pr-[38px] mobile-or-landscape:pb-10',
  );

  return (
    <div className={containerClasses}>
      <div className="pointer-events-auto">{children}</div>
    </div>
  );
};

HeaderCta.displayName = 'HeaderCta';

export default React.memo(HeaderCta);
